import {EventBus} from "@/event-bus";

export default class ErrorService extends Error {
  constructor(error) {
    super(error)
    this.error = error.response
  }

  showError() {
    if ([500, 400].includes(this.error?.status)) {
      let message = 'Terjadi kesalahan';

      if (this.error?.data?.detail) {
        message = this.error.data.detail;
      } else if (this.error?.data && typeof this.error.data === 'object') {
        const messages = Object.entries(this.error.data)
            .filter(([key]) => key !== 'correlation_id')
            .map(([, value]) => value)
            .join(', ');
        if (messages) {
          message = messages;
        }
      } else if (typeof this.error?.data === 'string') {
        message = this.error.data;
      }

      EventBus.$emit('notify', {
        message,
        type: this.error?.status == 400 ? 'warning' : 'danger'
      });
    }
  }
}
